import { useConfig } from '../hooks/useConfig/useConfig';
import FullRoutes from './routes.full';
import MicrositeRoutes from './routes.microsite';

/* -------------------------------- Component ------------------------------- */

const Router = () => {
    const {
        device: {
            web: { siteType },
        },
    } = useConfig();

    if (siteType === 'microsite') return <MicrositeRoutes />;

    return <FullRoutes />;
};

/* --------------------------------- Export --------------------------------- */

export default Router;
